import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CrewTimecardGridService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getBulkEmployeeList(pRCo, pRGroup) {
    const url = '/CrewTimecard/GetBulkEmployeeList?pRCo=' + pRCo + '&pRGroup=' + pRGroup;
    return this.http.get(url).toPromise();
  }

  getCellPossibleValues(rowData) {
    const url = '/Timecard/GetCellPossibleValues';
    return this.http.post('/Timecard/GetCellPossibleValues', rowData).toPromise();
  }

  getColumnsByPRCoGroup(pRCo, pRGroup, isCrewOrStandard) {
    const url = '/CrewTimecard/GetColumnsByPRCoGroup?pRCo=' + pRCo + '&pRGroup=' + pRGroup + '&isCrewOrStandard=' + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getCrews(pRCo, pRGRoup) {
    const url = '/CrewTimecard/GetCrews?PRCo=' + pRCo + '&PRGroup=' + pRGRoup;
    return this.http.get(url).toPromise();
  }

  getCrewTimecardData(pRPCKeyID, crewTemplateID) {
    const url = '/CrewTimecard/Data?payPeriodId=' + pRPCKeyID + '&templateId=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getDailyOtherHours(employeeString, pRCo, pRPCKeyID, crewTemplateID) {
    const url =
      '/Timecard/GetDailyOtherHours?employee=' +
      employeeString +
      '&pRCo=' +
      pRCo +
      '&pRPCKeyID=' +
      pRPCKeyID +
      '&crewTemplateID=' +
      crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getDefaultsForEmplList(pREHKeyIDString) {
    const url = '/CrewTimecard/GetDefaultsForEmplList?pREHKeyIDString=' + pREHKeyIDString;
    return this.http.get(url).toPromise();
  }

  getEmplLockStatus(hQBCKeyID, crewTemplateID) {
    const url = '/CrewTimecard/GetEmplLockStatus?hQBCKeyID=' + hQBCKeyID + '&crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTimecardColumns(employeeId: number, employee: number, pRCo: number, pRGroup: number, filterType: string, isCrewOrStandard: string) {
    const url =
      '/Timecard/GetTimecardColumns?employeeId=' +
      employeeId +
      '&employee=' +
      employee +
      '&pRCo=' +
      pRCo +
      '&pRGroup=' +
      pRGroup +
      '&isCrewOrStandard=' +
      isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getApprovalDailyTotals(pRPCKeyID: number) {
    const url = '/Approval/GetApprovalDailyTotals?pRPCKeyID=' + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  getRow(rowId) {
    const url = '/Timecard/Row?rowId=' + rowId;
    return this.http.get(url).toPromise();
  }

  approveCrewTimecard(crewTemplateID, pRPCKeyID, keyID, submittedOnString, keyIDString = null) {
    const url = '/CrewTimecard/ApproveCrewTimecard';
    const postData: any = {
      crewTemplateID: crewTemplateID,
      pRPCKeyID: pRPCKeyID,
      keyID: keyID,
      submittedOnString: submittedOnString,
    };
    if (keyIDString != null) postData.keyIDString = keyIDString;
    return this.http.post(url, postData).toPromise();
  }

  deleteTimecardRow(rowId) {
    const url = '/Timecard/DeleteTimecardRow';
    return this.http.post(url, { rowId: rowId }).toPromise();
  }

  //CrewTemplateID is not used in job approval,
  saveCrewTimecard(timecardId, rows, crewTemplateID = null, jCFTKeyID = null, fromJobApproval = false) {
    const url = '/CrewTimecard/SaveCrewTimecard';
    const postData: any = {
      timecardId: timecardId,
      rows: rows,
      employee: -1,
      fromJobApproval: fromJobApproval,
    };
    if (crewTemplateID != null) postData.crewTemplateID = crewTemplateID;
    if (jCFTKeyID != null) postData.jcftKeyID = jCFTKeyID;
    return this.http.post(url, postData).toPromise();
  }

  getTimecardApprovalGrid(pRPCKeyID, hQBCKeyID, jCJMKeyID, approvalStatus) {
    let url = '/Approval/GetTimecardApprovalGrid?pRPCKeyID=' + pRPCKeyID;
    if (jCJMKeyID != null) url += '&jCJMKeyID=' + jCJMKeyID;
    if (hQBCKeyID != null) url += '&hQBCKeyID=' + hQBCKeyID;
    if (approvalStatus != null) url += '&approvalStatus=' + approvalStatus;
    return this.http.get(url).toPromise();
  }

  timecardApprovalSubmit(pRPCKeyID, pRTBKeyIDString, actionCode, rejectReason: string = null, rejectNotes: string = null) {
    const url = '/Approval/TimecardApprovalSubmit';
    const postData: any = {
      pRPCKeyID: pRPCKeyID,
      pRTBKeyIDString: pRTBKeyIDString,
      actionCode: actionCode,
    };
    if (rejectReason != null) {
      postData.rejectReason = rejectReason;
      postData.rejectNotes = rejectNotes;
    }
    return this.http.post(url, postData).toPromise();
  }

  timecardApprovalFinalize(pRPCKeyID, pRTBKeyIDString) {
    const url = '/Approval/TimecardApprovalFinalize';
    const postData: any = {
      pRPCKeyID: pRPCKeyID,
      pRTBKeyIDString: pRTBKeyIDString,
    };
    return this.http.post(url, postData).toPromise();
  }

  saveCompilePDFData(pREndDate, pRTBKeyIDString, pRPCKeyID) {
    const url = '/Approval/SaveCompilePDFData';
    const postData = {
      pREndDate: pREndDate,
      pRTBKeyIDString: pRTBKeyIDString,
      PRPCKeyID: pRPCKeyID,
    };
    return this.http.post(url, postData).toPromise();
  }

  downloadCompilePDFFile(pREndDate) {
    const url = '/Approval/DownloadCompilePDFFile?pREndDate=' + pREndDate;
    return this.http.get(url).toPromise();
  }
}
